export let StateData = [
    {
        ID: 0,
        Name: "National",
        Abbr: "US",
        RatioToNationalEmployed: 1.0,
        RatioToNationalGeneral: 1.0,
        SuicidalFactor: .046,
        ComorbidSUDFactor: .049,
        DepressionFactor:.073,
    },
    {
        ID: 1,
        Name: "Alabama",
        Abbr: "AL",
        RatioToNationalEmployed: 1.1,
        RatioToNationalGeneral: 1.11,
        SuicidalFactor: .063,
        ComorbidSUDFactor: .071,
        DepressionFactor:.09,
    },
    {
        ID: 2,
        Name: "Alaska",
        Abbr: "AK",
        RatioToNationalEmployed: 1.02,
        RatioToNationalGeneral: 1.05,
        SuicidalFactor: .064,
        ComorbidSUDFactor: .047,
        DepressionFactor:.08,
    },
    {
        ID: 3,
        Name: "Arizona",
        Abbr: "AZ",
        RatioToNationalEmployed: 0.99,
        RatioToNationalGeneral: 0.99,
        SuicidalFactor: .056,
        ComorbidSUDFactor: .045,
        DepressionFactor:.077,
    },
    {
        ID: 4,
        Name: "Arkansas",
        Abbr: "AR",
        RatioToNationalEmployed: 1.07,
        RatioToNationalGeneral: 1.19,
        SuicidalFactor: .042,
        ComorbidSUDFactor: .068,
        DepressionFactor:.075,
    },
    {
        ID: 5,
        Name: "California",
        Abbr: "CA",
        RatioToNationalEmployed: 1.01,
        RatioToNationalGeneral: 0.94,
        SuicidalFactor: .048,
        ComorbidSUDFactor: .05,
        DepressionFactor:.076,
    },
    {
        ID: 6,
        Name: "Colorado",
        Abbr: "CO",
        RatioToNationalEmployed: 1.11,
        RatioToNationalGeneral: 1.08,
        SuicidalFactor: .062,
        ComorbidSUDFactor: .131,
        DepressionFactor:.096,
    },
    {
        ID: 7,
        Name: "Connecticut",
        Abbr: "CT",
        RatioToNationalEmployed: 0.97,
        RatioToNationalGeneral: 0.99,
        SuicidalFactor: .033,
        ComorbidSUDFactor: .052,
        DepressionFactor:.055,
    },
    {
        ID: 8,
        Name: "Delaware",
        Abbr: "DE",
        RatioToNationalEmployed: 1.05,
        RatioToNationalGeneral: 1.04,
        SuicidalFactor: .058,
        ComorbidSUDFactor: .052,
        DepressionFactor:.078,
    },
    {
        ID: 9,
        Name: "District of Columbia",
        Abbr: "DC",
        RatioToNationalEmployed: 1.16,
        RatioToNationalGeneral: 1.08,
        SuicidalFactor: .035,
        ComorbidSUDFactor: .173,
        DepressionFactor:.086,
    },
    {
        ID: 10,
        Name: "Florida",
        Abbr: "FL",
        RatioToNationalEmployed: 0.87,
        RatioToNationalGeneral: 0.87,
        SuicidalFactor: .04,
        ComorbidSUDFactor: .027,
        DepressionFactor:.065,
    },
    {
        ID: 11,
        Name: "Georgia",
        Abbr: "GA",
        RatioToNationalEmployed: 0.92,
        RatioToNationalGeneral: 0.95,
        SuicidalFactor: .032,
        ComorbidSUDFactor: .026,
        DepressionFactor:.054,
    },
    {
        ID: 12,
        Name: "Hawaii",
        Abbr: "HI",
        RatioToNationalEmployed: 0.88,
        RatioToNationalGeneral: 0.91,
        SuicidalFactor: .054,
        ComorbidSUDFactor: .046,
        DepressionFactor:.052,
    },
    {
        ID: 13,
        Name: "Idaho",
        Abbr: "ID",
        RatioToNationalEmployed: 1.28,
        RatioToNationalGeneral: 1.19,
        SuicidalFactor: .056,
        ComorbidSUDFactor: .062,
        DepressionFactor:.09,
    },
    {
        ID: 14,
        Name: "Illinois",
        Abbr: "IL",
        RatioToNationalEmployed: 0.91,
        RatioToNationalGeneral: 0.89,
        SuicidalFactor: .036,
        ComorbidSUDFactor: .034,
        DepressionFactor:.061,
    },
    {
        ID: 15,
        Name: "Indiana",
        Abbr: "IN",
        RatioToNationalEmployed: 1.27,
        RatioToNationalGeneral: 1.25,
        SuicidalFactor: .059,
        ComorbidSUDFactor: .041,
        DepressionFactor:.09
    },
    {
        ID: 16,
        Name: "Iowa",
        Abbr: "IA",
        RatioToNationalEmployed: 1.04,
        RatioToNationalGeneral: 1.01,
        SuicidalFactor: .045,
        ComorbidSUDFactor: .037,
        DepressionFactor:.069,
    },
    {
        ID: 17,
        Name: "Kansas",
        Abbr: "KS",
        RatioToNationalEmployed: 1.01,
        RatioToNationalGeneral: 1.01,
        SuicidalFactor: .046,
        ComorbidSUDFactor: .036,
        DepressionFactor:.067,
    },
    {
        ID: 18,
        Name: "Kentucky",
        Abbr: "KY",
        RatioToNationalEmployed: 0.12,
        RatioToNationalGeneral: 1.24,
        SuicidalFactor: .046,
        ComorbidSUDFactor: .031,
        DepressionFactor:.084,
    },
    {
        ID: 19,
        Name: "Louisiana",
        Abbr: "LA",
        RatioToNationalEmployed: 0.91,
        RatioToNationalGeneral: 1.01,
        SuicidalFactor: .047,
        ComorbidSUDFactor: .045,
        DepressionFactor:.064,
    },
    {
        ID: 20,
        Name: "Maine",
        Abbr: "ME",
        RatioToNationalEmployed: 1.03,
        RatioToNationalGeneral: 1.01,
        SuicidalFactor: .069,
        ComorbidSUDFactor: .032,
        DepressionFactor:.09,
    },
    {
        ID: 21,
        Name: "Maryland",
        Abbr: "MD",
        RatioToNationalEmployed: 0.88,
        RatioToNationalGeneral: 0.9,
        SuicidalFactor: .036,
        ComorbidSUDFactor: .041,
        DepressionFactor:.063,
    },
    {
        ID: 22,
        Name: "Massachusetts",
        Abbr: "MA",
        RatioToNationalEmployed: 1.03,
        RatioToNationalGeneral: 1.06,
        SuicidalFactor: .041,
        ComorbidSUDFactor: .083,
        DepressionFactor:.069,
    },
    {
        ID: 23,
        Name: "Michigan",
        Abbr: "MI",
        RatioToNationalEmployed: 0.99,
        RatioToNationalGeneral: 1.05,
        SuicidalFactor: .048,
        ComorbidSUDFactor: .097,
        DepressionFactor:.079,
    },
    {
        ID: 24,
        Name: "Minnesota",
        Abbr: "MN",
        RatioToNationalEmployed: 0.94,
        RatioToNationalGeneral: 0.92,
        SuicidalFactor: .048,
        ComorbidSUDFactor: .057,
        DepressionFactor:.08,
    },
    {
        ID: 25,
        Name: "Mississippi",
        Abbr: "MS",
        RatioToNationalEmployed: 1.02,
        RatioToNationalGeneral: 1.05,
        SuicidalFactor: .052,
        ComorbidSUDFactor: .02,
        DepressionFactor:.063,

    },
    {
        ID: 26,
        Name: "Missouri",
        Abbr: "MO",
        RatioToNationalEmployed: 1.09,
        RatioToNationalGeneral: 1.09,
        SuicidalFactor: .049,
        ComorbidSUDFactor: .033,
        DepressionFactor:.096,
    },
    {
        ID: 27,
        Name: "Montana",
        Abbr: "MT",
        RatioToNationalEmployed: 1.10,
        RatioToNationalGeneral: 1.08,
        SuicidalFactor: .045,
        ComorbidSUDFactor: .089,
        DepressionFactor:.081,
    },
    {
        ID: 28,
        Name: "Nebraska",
        Abbr: "NE",
        RatioToNationalEmployed: 0.98,
        RatioToNationalGeneral: 0.94,
        SuicidalFactor: .047,
        ComorbidSUDFactor: .069,
        DepressionFactor:.069,
    },
    {
        ID: 29,
        Name: "Nevada",
        Abbr: "NV",
        RatioToNationalEmployed: 1.15,
        RatioToNationalGeneral: 1.1,
        SuicidalFactor: .063,
        ComorbidSUDFactor: .109,
        DepressionFactor:.91,
    },
    {
        ID: 30,
        Name: "New Hampshire",
        Abbr: "NH",
        RatioToNationalEmployed: 1.18,
        RatioToNationalGeneral: 1.09,
        SuicidalFactor: .048,
        ComorbidSUDFactor: .093,
        DepressionFactor:.095,
    },
    {
        ID: 31,
        Name: "New Jersey",
        Abbr: "NJ",
        RatioToNationalEmployed: 0.85,
        RatioToNationalGeneral: 0.93,
        SuicidalFactor: .032,
        ComorbidSUDFactor: .033,
        DepressionFactor:.055,
    },
    {
        ID: 32,
        Name: "New Mexico",
        Abbr: "NM",
        RatioToNationalEmployed: 1.09,
        RatioToNationalGeneral: 1.08,
        SuicidalFactor: .06,
        ComorbidSUDFactor: .015,
        DepressionFactor:.09,
    },
    {
        ID: 33,
        Name: "New York",
        Abbr: "NY",
        RatioToNationalEmployed: 0.97,
        RatioToNationalGeneral: 0.98
    },
    {
        ID: 34,
        Name: "North Carolina",
        Abbr: "NC",
        RatioToNationalEmployed: 0.94,
        RatioToNationalGeneral: 1.03,
        SuicidalFactor: .041,
        ComorbidSUDFactor: .036,
        DepressionFactor:.062,
    },
    {
        ID: 35,
        Name: "North Dakota",
        Abbr: "ND",
        RatioToNationalEmployed: 0.95,
        RatioToNationalGeneral: 0.94,
        SuicidalFactor: .049,
        ComorbidSUDFactor: .03,
        DepressionFactor:.073,
    },
    {
        ID: 36,
        Name: "Ohio",
        Abbr: "OH",
        RatioToNationalEmployed: 1.15,
        RatioToNationalGeneral: 1.12,
        SuicidalFactor: .066,
        ComorbidSUDFactor: .068,
        DepressionFactor:.086,
    },
    {
        ID: 37,
        Name: "Oklahoma",
        Abbr: "OK",
        RatioToNationalEmployed: 1.01,
        RatioToNationalGeneral: 1.06,
        SuicidalFactor: .047,
        ComorbidSUDFactor: .019,
        DepressionFactor:.082,
    },
    {
        ID: 38,
        Name: "Oregon",
        Abbr: "OR",
        RatioToNationalEmployed: 1.26,
        RatioToNationalGeneral: 1.28,
        SuicidalFactor: .068,
        ComorbidSUDFactor: .063,
        DepressionFactor:.112,
    },
    {
        ID: 39,
        Name: "Pennsylvania",
        Abbr: "PA",
        RatioToNationalEmployed: 1.0,
        RatioToNationalGeneral: 1.01,
        SuicidalFactor: .047,
        ComorbidSUDFactor: .046,
        DepressionFactor:.077,
    },
    {
        ID: 40,
        Name: "Rhode Island",
        Abbr: "RI",
        RatioToNationalEmployed: 1.08,
        RatioToNationalGeneral: 1.09,
        SuicidalFactor: .045,
        ComorbidSUDFactor: .045,
        DepressionFactor:.08,
    },
    {
        ID: 41,
        Name: "South Carolina",
        Abbr: "SC",
        RatioToNationalEmployed: 0.92,
        RatioToNationalGeneral: 0.92,
        SuicidalFactor: .051,
        ComorbidSUDFactor: .018,
        DepressionFactor:.076,
    },
    {
        ID: 42,
        Name: "South Dakota",
        Abbr: "SD",
        RatioToNationalEmployed: 1.08,
        RatioToNationalGeneral: 0.97,
        SuicidalFactor: .044,
        ComorbidSUDFactor: .083,
        DepressionFactor:.067,
    },
    {
        ID: 43,
        Name: "Tennessee",
        Abbr: "TN",
        RatioToNationalEmployed: 0.94,
        RatioToNationalGeneral: 1.05,
        SuicidalFactor: .052,
        ComorbidSUDFactor: .044,
        DepressionFactor:.062,
    },
    {
        ID: 44,
        Name: "Texas",
        Abbr: "TX",
        RatioToNationalEmployed: 0.82,
        RatioToNationalGeneral: 0.84,
        SuicidalFactor: .036,
        ComorbidSUDFactor: .033,
        DepressionFactor:.056,
    },
    {
        ID: 45,
        Name: "Utah",
        Abbr: "UT",
        RatioToNationalEmployed: 1.43,
        RatioToNationalGeneral: 1.05,
        SuicidalFactor: .064,
        ComorbidSUDFactor: .043,
        DepressionFactor:.096,
    },
    {
        ID: 46,
        Name: "Vermont",
        Abbr: "VT",
        RatioToNationalEmployed: 1.07,
        RatioToNationalGeneral: 1.17,
        SuicidalFactor: .065,
        ComorbidSUDFactor: .054,
        DepressionFactor:.089,
    },
    {
        ID: 47,
        Name: "Virginia",
        Abbr: "VA",
        RatioToNationalEmployed: 1.03,
        RatioToNationalGeneral: 1.04,
        SuicidalFactor: .037,
        ComorbidSUDFactor: .065,
        DepressionFactor:.067,
    },
    {
        ID: 48,
        Name: "Washington",
        Abbr: "WA",
        RatioToNationalEmployed: 1.16,
        RatioToNationalGeneral: 1.20,
        SuicidalFactor: .046,
        ComorbidSUDFactor: .015,
        DepressionFactor:.097,
    },
    {
        ID: 49,
        Name: "West Virginia",
        Abbr: "WV",
        RatioToNationalEmployed: 1.22,
        RatioToNationalGeneral: 1.28,
        SuicidalFactor: .058,
        ComorbidSUDFactor: .03,
        DepressionFactor:.108,
    },
    {
        ID: 50,
        Name: "Wisconsin",
        Abbr: "WI",
        RatioToNationalEmployed: 1.07,
        RatioToNationalGeneral: 1.00,
        SuicidalFactor: .047,
        ComorbidSUDFactor: .121,
        DepressionFactor:.97,
    },
    {
        ID: 51,
        Name: "Wyoming",
        Abbr: "WY",
        RatioToNationalEmployed: 1.03,
        RatioToNationalGeneral: 1.03,
        SuicidalFactor: .065,
        ComorbidSUDFactor: .082,
        DepressionFactor:.069,
    }
];
export let IndustryData = [
    {
        ID: 0,
        Name: "Overall average",
        DistressFactor: .0925,
        AbsenteeismCost: 4783,
        TurnoverCost: 5733,
        OverallExcessCost: 16555,
        RatioToAverage: 1
    },
    {
        ID: 1,
        Name: "Agriculture",
        DistressFactor: .059,
        AbsenteeismCost: 1529,
        TurnoverCost: 1833,
        OverallExcessCost: 8751,
        RatioToAverage: .637838
    },
    {
        ID: 2,
        Name: "Mining",
        DistressFactor: .0355,
        AbsenteeismCost: 4572,
        TurnoverCost: 5481,
        OverallExcessCost: 16050,
        RatioToAverage: .383784

    },
    {
        ID: 3,
        Name: "Construction",
        DistressFactor: .0640,
        AbsenteeismCost: 5224,
        TurnoverCost: 6263,
        OverallExcessCost: 17614,
        RatioToAverage: .691892
    },
    {
        ID: 4,
        Name: "Manufacturing, nondurable",
        DistressFactor: .0765,
        AbsenteeismCost: 5167,
        TurnoverCost: 6195,
        OverallExcessCost: 17478,
        RatioToAverage: .827027
    },
    {
        ID: 5,
        Name: "Manufacturing, durable",
        DistressFactor: .0715,
        AbsenteeismCost: 5167,
        TurnoverCost: 6195,
        OverallExcessCost: 17478,
        RatioToAverage: .772973
    },
    {
        ID: 6,
        Name: "Transportation",
        DistressFactor: .0705,
        AbsenteeismCost: 5055,
        TurnoverCost: 6060,
        OverallExcessCost: 17208,
        RatioToAverage: .762162
    },
    {
        ID: 7,
        Name: "Utilities",
        DistressFactor: .0705,
        AbsenteeismCost: 8226,
        TurnoverCost: 9861,
        OverallExcessCost: 24814,
        RatioToAverage: .762162
    },
    {
        ID: 8,
        Name: "Information, communications",
        DistressFactor: .105,
        AbsenteeismCost: 7532,
        TurnoverCost: 9030,
        OverallExcessCost: 23151,
        RatioToAverage: 1.135135
    },
    {
        ID: 9,
        Name: "Wholesale, durable",
        DistressFactor: .0550,
        AbsenteeismCost: 4882,
        TurnoverCost: 5853,
        OverallExcessCost: 16793,
        RatioToAverage: .594595
    },
    {
        ID: 10,
        Name: "Wholesale, nondurable",
        DistressFactor: .0570,
        AbsenteeismCost: 4882,
        TurnoverCost: 5853,
        OverallExcessCost: 16793,
        RatioToAverage: .616216
    },
    {
        ID: 11,
        Name: "Retail",
        DistressFactor: .119,
        AbsenteeismCost: 2653,
        TurnoverCost: 3180,
        OverallExcessCost: 11446,
        RatioToAverage: 1.286486
    },
    {
        ID: 12,
        Name: "Finance, insurance, real estate",
        DistressFactor: .072,
        AbsenteeismCost: 6924,
        TurnoverCost: 8300,
        OverallExcessCost: 21691,
        RatioToAverage: .778378
    },
    {
        ID: 13,
        Name: "Professional, management, administration",
        DistressFactor: .098,
        AbsenteeismCost: 6262,
        TurnoverCost: 7495,
        OverallExcessCost: 20080,
        RatioToAverage: 1.059459
    },
    {
        ID: 14,
        Name: "Education, health, social services",
        DistressFactor: .0955,
        AbsenteeismCost: 4854,
        TurnoverCost: 5819,
        OverallExcessCost: 16725,
        RatioToAverage: 1.032432
    },
    {
        ID: 15,
        Name: "Entertainment, recreation, food",
        DistressFactor: .153,
        AbsenteeismCost: 2041,
        TurnoverCost: 2446,
        OverallExcessCost: 9977,
        RatioToAverage: 1.654054
    },
    {
        ID: 16,
        Name: "Public administration",
        DistressFactor: .064,
        AbsenteeismCost: 6420,
        TurnoverCost: 7697,
        OverallExcessCost: 20483,
        RatioToAverage: .691892
    },
    {
        ID: 17,
        Name: "Other services except public administration",
        DistressFactor: .1045,
        AbsenteeismCost: 3813,
        TurnoverCost: 4571,
        OverallExcessCost: 16555,
        RatioToAverage: 1.12973
    }
];
export let ModalData = {
    "smallsample": {
        "title": "Small Sample Warning",
        "text": "<p>With 100 or fewer employees, the data generated by this form will be less relevant.</p>"
    },
    "intro": {
        "title": "The Mental Health Cost Calculator for Employers",
        "text": "<p>Severe psychological distress affected approximately 16.2 million working people in the previous 12 months and affected 10.6 million non-workers ages 12 to 65 years.  NHSDA projects that 9.8 million working people experienced at least one major depressive episode in the prior year, and 7.0 million non-workers had a depressive episode.   There were 13.4 million workers who had an alcohol lor drug use disorder, 4.0 million of whom also had severe psychological distress.   Among non-workers,  10.6 million had an alcohol or drug use disorder in the last year, 2.2 million of whom also had severe psychological distress.</p><p>Although 61% of people reporting severe psychological distress (and 58% of those reporting a major depressive episode in the last year) are part of the workforce, most employers are unaware of the hidden costs associated with these conditions.   Workplaces bear significant costs due to absenteeism, increased healthcare expenses and turnover, and lost productivity.</p><p>This calculator combines the latest research on employment costs with public use data from the 2015 to 2019 National Surveys on Drug Use and Health (NSDUH)<sup><a href=\"https://www.nsc.org/workplace/safety-topics/employee-mental-health/cost-calculator-citations\" class=\"font-weight-bold txtlightblue\" target=\"_blank\">1</a></sup> a large government sponsored annual survey.   The calculator shows the likely costs of untreated distress in your workforce.  In addition, the calculator provides resources to support employers, employees' and their families' recovery.</p>"
    },
    "losttime": {
        "title": "Workdays Missed and Costs",
        "text": "<p>The NSDUH asks respondents to recall how often they missed work due to illness and injury or skipped work in the past 30 days. Responses to these two questions are summed and annualized to measure the total number of missed workdays per year.  For each industry sector, the average number of unscheduled workdays missed by a worker experiencing serious psychological distress in the prior 12 months was compared with the average number of days missed by all workers in that sector.   The direct costs of unscheduled leave were computed by multiplying those averages by the fully loaded daily wage data for each sector published by the US Bureau of Labor Statistics.<sup><a href=\"https://www.nsc.org/workplace/safety-topics/employee-mental-health/cost-calculator-citations\" class=\"font-weight-bold txtlightblue\" target=\"_blank\">2</a></sup> The actual cost of unscheduled leave may significantly underestimate the true costs to employers who must cover missed work with substitute personnel.</p>"
    },
    "turnover": {
        "title": "Turn-over, Replacement and Turnover Costs",
        "text": "<p>Serious psychological distress (SPD) is associated with a number of hazardous and costly social consequences that can have negative impacts in the workplace.  Studies place the average cost to employers of recruiting and training replacement workers at 21 percent of an employee's annual fully loaded salary.<sup><a href=\"https://www.nsc.org/workplace/safety-topics/employee-mental-health/cost-calculator-citations\" class=\"font-weight-bold txtlightblue\" target=\"_blank\">3, 4</a></sup> Replacement and retraining costs are greater for workers with more education and training, and lower for workers paid less and with fewer skills.  For the Calculator, employers' turn-over costs are computed from the difference in rates of one year turn-over in each industry sector of workers with and without SPD and the estimated costs of replacement in that sector.<sup><a href=\"https://www.nsc.org/workplace/safety-topics/employee-mental-health/cost-calculator-citations\" class=\"font-weight-bold txtlightblue\" target=\"_blank\">5</a></sup></p>"
    },
    "healthcare": {
        "title": "Health Care Use and Costs",
        "text": "<p>Respondents are asked about health care use in the prior 12 months: how many times they had gone to a hospital emergency room, whether they had been hospitalized overnight, and, if so, for how many nights, and the number of outpatient primary care visits.  Respondents were also asked about past 12 month and lifetime mental health and substance use treatment.   To estimate health care costs more precisely for individual employers that are associated with serious psychological distress in their workforce and among the dependents of their employees , we calculated from NSDUH the average hospital, emergency department, and ambulatory primary care use, medications, mental health and substance use treatment in the previous 12 months by workers with or with no serious psychological distress. Use by workers' family members experiencing serious psychological stress was estimated from the overall prevalence of SPD among NHSDUH respondents aged 12 to 65 years, and the health care use of those with and with no SPD in that age group.    Utilization was then multiplied by the most recently available Federal government and health care industry data on average paid claims for hospital nights, ED and ambulatory care visits.<sup><a href=\"https://www.nsc.org/workplace/safety-topics/employee-mental-health/cost-calculator-citations\" class=\"font-weight-bold txtlightblue\" target=\"_blank\">6, 7, 8</a></sup> Employers that offer health insurance to their employees cover, on average, 79% of individual workers' premiums and 73% of family premiums<sup><a href=\"https://www.nsc.org/workplace/safety-topics/employee-mental-health/cost-calculator-citations\" class=\"font-weight-bold txtlightblue\" target=\"_blank\">9</a></sup>. Employers' costs were discounted by the percentage of employer's premium support for individual workers and for dependents. </p>"
    },
    "affected": {
        "title": "How is the number of employees and dependents of employees with severe psychological distress calculated?",
        "text": "<p>Your total number of employees with a severe psychological distress<sup><a href=\"https://www.nsc.org/workplace/safety-topics/employee-mental-health/cost-calculator-citations\" class=\"font-weight-bold txtlightblue\" target=\"_blank\">10</a></sup> was  determined by multiplying the prevalence of severe psychological distress in your state and industry (as determined from responses from the NSDUH in 2015-2018) by the number of your employees.   Similarly, the estimated number of family members of your employees who had a severe psychological distress was found by multiplying the number of employees times the average household size over 12 years of age (1.52) by the rate of severe psychological distress  among people 12 and over in your state.</p><p>In 2018, approximately 16.2 million working people had a severe psychological distress, and 10.6 million non-workers ages 12 to 65 had a severe psychological distress in the prior year.   NHSDA estimated that 9.8 million working people experienced at least one major depressive episode in the prior year, and 7.0 million non-workers had a depressive episode.   There were 13.4 million workers who had an alcohol lor drug use disorder, 4.0 million of whom also had severe psychological distress.   Among non-workers,  10.6 million had an alcohol or drug use disorder in the last year, 2.2 million of whom also had severe psychological distress.</p>"
    },
    "employees": {
        "title": "How is the number of employees who experienced severe psychological distress calculated?",
        "text": "<p>Your total number of employees with a severe psychological distress<sup><a href=\"https://www.nsc.org/workplace/safety-topics/employee-mental-health/cost-calculator-citations\" class=\"font-weight-bold txtlightblue\" target=\"_blank\">11</a></sup> was determined by multiplying the prevalence of severe psychological distress in your state and industry (as determined from responses from the NSDUH in 2015-2018) by the number of your employees.</p>"
    },
    "dependents": {
        "title": "How is the number of dependents of employees who experienced severe psychological distress calculated?",
        "text": "<p>The estimated number of family members of your employees who had a severe psychological distress<sup><a href=\"https://www.nsc.org/workplace/safety-topics/employee-mental-health/cost-calculator-citations\" class=\"font-weight-bold txtlightblue\" target=\"_blank\">12</a></sup> was found by multiplying the number of employees times the average household size over 12 years of age (1.18) by the rate of severe psychological distress among people 12 and over in your state (as determined from responses from the NSDUH in 2015-2018).</p>"
    },
    "depression": {
        "title": "How is the number of employees and dependents of employees experiencing a major depressive episode in the past year calculated?",
        "text": "<p>Your total number of employees who experienced a major depressive episode (significant depressive symptoms lasting 2 weeks or longer) was determined by multiplying the prevalence of past year major depression your state and industry times the total number of your employees.   Similarly, the estimated number of family members of your employees who experienced a major depressive episode was determined by multiplying the number of employees times the average household size over 12 years of age (1.18) by the rate of depression among people 12 and over in your state.  The average prevalence of depression measured by the NSDUH surveys in 2018 and 2019 were used in the calculations.  More than 3 in 5 adults who experience a major depressive episode in the prior year work.  Patterns of depression by industry sector generally mirror those of psychological distress.  Especially low rates of depression were found in agriculture (1.4%), transportation and utilities (2.9%),  and nondurable goods wholesale trades (2.9%). Higher than average rates were found in entertainment, recreation, food service, retail, information, communications, professional and management.</p>"
    },
    "anxiety": {
        "title": "How is the number of employees and their dependents who experienced severe anxiety episodes in the last year calculated?",
        "text": "<p>NSDUH does not produce estimates of anxiety in employed or general populations. The National Health Interview Survey, an annual CDC survey,<sup><a href=\"https://www.nsc.org/workplace/safety-topics/employee-mental-health/cost-calculator-citations\" class=\"font-weight-bold txtlightblue\" target=\"_blank\">13</a></sup> does ask respondents does ask a nationally representative sample of civilian adults 18 years and older and over how often in the past 30 days they felt nervous. Respondents could choose from among five response categories: \"All of the time\", \"Most of the time\", \"Some of the time\", \"A little of the time\", or \"None of the time\". \"All\" and \"Most\" are combined.  Rates of serious anxiety for employed populations was 4.4% in 2018 and in the general population was 5.9%.</p>"
    },
    "suicide": {
        "title": "How is the number of employees and their dependents who experienced suicidal thoughts in the last year calculated?",
        "text": "<p>Your total number of employees who experienced suicidal thoughts was determined by multiplying the prevalence of suicidal thoughts in the past year (based on estimates from the NSDUH 2018-2019) by the total number of your employees.   Similarly, the estimated number of family members of your employees who experienced suicidal thoughts was determined by multiplying the number of employees times the average household size over 12 years of age (1.18) by the rate of suicidal thoughts among people 12 and over.  The average prevalence of suicidal thoughts as measured by the NSDUH surveys in 2018 and 2019 were 6.3% for employed populations and 5.9% in the general population.</p>"
    },
    "substance": {
        "title": "How is the number of employees and their dependents with comorbid serious psychological distress and substance use disorders calculated?",
        "text": "<p>Your total number of employees with comorbid distress and substance use disorders (SUDs) was determined by multiplying the number of your employees in your state and industry with distress (as estimated from the 2018-2019 NSDUH) by the percent who also reported an SUD.   Nationwide, a third of employed workers who experienced serious psychological distress in the prior year also had a comorbid substance use disorder during that year.   Similarly, the estimated number of dependents of your employees who had comorbid distress and SUD was estimated by multiplying the number of employees times the average household size over 12 years of age (1.18) by the rate of distress among people 12 and over in your state (as estimated from the 2018-2019 NSDUH) by the percent who also reported an SUD.  Again, one-third of the general population who experienced distress had a comorbid SUD.</p>"
    }
};